import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './../../Style/GenericTitle.module.scss';

interface TitleProps {
    titleName: string;
    children?: string | string[] | React.ReactElement;
}
const Title: React.FC<TitleProps> = ({ titleName, children }) => {
    const { t } = useTranslation();
    return (
        <div className={Styles.titleContainer}>
            <span className={Styles.title}>{t(titleName)}</span>
            {children}
        </div>
    );
};

export default Title;
